import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';
import { Alert, AlertDescription, AlertTitle } from '@repo/ui/alert';
import { DisableAuthenticatorAppDialog } from '@/components/forms/2fa/disable-authenticator-app-dialog';
import { EnableAuthenticatorAppDialog } from '@/components/forms/2fa/enable-authenticator-app-dialog';
import { ViewRecoveryCodesDialog } from '@/components/forms/2fa/view-recovery-codes-dialog';
import { SettingsHeader } from '@/components/settings-header';
import { useSession } from '@/providers/session';

export const TwoFactorSetting = () => {
  useLocale();

  const { user } = useSession();
  return (
    <div className="raven-page raven-settings">
      <SettingsHeader
        subtitle={t('auth.hereYouCanManageYourTwoFactorAuthenticationSettings')}
        title={t('auth.security')}
      />
      <Alert
        className="mt-6 flex flex-col justify-between p-6 sm:flex-row sm:items-center"
        variant="default"
      >
        <div className="mb-4 sm:mb-0">
          <AlertTitle>{t('auth.twoFactorAuthentication2')}</AlertTitle>

          <AlertDescription className="me-4">
            {t('auth.addAnAuthenticatorToServeAsASecondaryAuthentication')}{' '}
          </AlertDescription>
        </div>

        {user.twoFactorEnabled ? (
          <DisableAuthenticatorAppDialog />
        ) : (
          <EnableAuthenticatorAppDialog />
        )}
      </Alert>

      {user.twoFactorEnabled && (
        <Alert
          className="mt-6 flex flex-col justify-between p-6 sm:flex-row sm:items-center"
          variant="default"
        >
          <div className="mb-4 sm:mb-0">
            <AlertTitle>{t('auth.recoveryCodes')}</AlertTitle>

            <AlertDescription className="me-4">
              {t('auth.twoFactorAuthenticationRecoveryCodesAreUsedToAccess')}{' '}
            </AlertDescription>
          </div>

          <ViewRecoveryCodesDialog />
        </Alert>
      )}
    </div>
  );
};
